<br>
<div class="container header">
  <h3 class="header__title">Measure Sampling</h3>
  <div class="header__button">
    <app-icon (click)="addMeasure()" iconName="plus-circle" iconStyle="far"></app-icon>
  </div>
</div>
<p class="w-50">
  Set individual review rates (“Overread”) for targeted measures. Measure Sampling is Part of Project Sampling
  configurations. For instance, a 50% (compliant) targeted measure sampling will ensure 50% compliant chases of that
  measure are overread, and these 50% compliant chases are part of the project’s sampling for compliant chases.
</p>
<br>
<ng-container *ngIf="measureFormOverread?.length > 0 else noMeasures">
  <div class="container flex-gap">
    <div class="grid">
      <p class="grid__header text-align-center">Overread I</p>
      <span class="text-align-left align-self container">Measure</span>
      <div class="container justify-center">
        <p>Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Partial Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Non-Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Exclusion</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <ng-container *ngFor="let measureGroup of measureFormOverread; let i = index; trackBy: trackByIndex">
        <ng-container
          *ngFor="let formGroup of getControls(measureGroup.formGroup); let j = index; trackBy: trackByIndex">
          <div class="container justify-center">
            <form-factory (onChange)="onInputChange($event)" class="input" [formGroup]="measureGroup.formGroup" [model]="measureGroup.models[j]"></form-factory>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="divisor"></div>
    <div class="grid">
      <p class="grid__header text-align-center">Overread II</p>
      <div class="container justify-center">
        <p>Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Partial Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Non-Compliant</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <div class="container justify-center">
        <p>Exclusion</p>
        <div class="icon">
          <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
        </div>
      </div>
      <span></span>
      <ng-container *ngFor="let measureGroup of measureFormOverread2; let i = index; trackBy: trackByIndex">
        <ng-container
          *ngFor="let formGroup of getControls(measureGroup.formGroup); let j = index; trackBy: trackByIndex">
          <div class="container justify-center">
            <form-factory class="input" [formGroup]="measureGroup.formGroup" [model]="measureGroup.models[j]"></form-factory>
          </div>
        </ng-container>
        <div class="container flex-gap ">
          <div class="action-button">
            <app-icon (click)="revertValues(i)" iconName="fas fa-sync"></app-icon>
          </div>
          <div class="action-button">
            <app-icon (click)="deleteRow(i)" iconName="fa-regular fa-trash"></app-icon>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-template #noMeasures>
  <p>No measure information.</p>
</ng-template>
